import { render, staticRenderFns } from "./FeedbackCom.vue?vue&type=template&id=0a06c1b3&scoped=true"
import script from "./FeedbackCom.vue?vue&type=script&lang=js"
export * from "./FeedbackCom.vue?vue&type=script&lang=js"
import style0 from "./FeedbackCom.vue?vue&type=style&index=0&id=0a06c1b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a06c1b3",
  null
  
)

export default component.exports